const LebanonSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111746)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="#D80027"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#D80027"
      />
      <path
        d="M25.2176 23.4783L20.0001 13.9131L14.7827 23.4783H18.6958V26.087H21.3045V23.4783H25.2176Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111746">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LebanonSvg;
